import { useEffect } from "react";
import { useAppParams } from "@router/router-helper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { groupsSelector } from "@store/groups/groups-selector";
import { fetchGroups } from "@store/groups/groups-slice-thunk";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** A hook that returns all groups the user has access to */
export function useGroups(): FaroCoreApiTypes.GroupSummaryResponse[] {
  const { companyId } = useAppParams();
  const dispatch = useAppDispatch();
  const groups = useAppSelector(groupsSelector);

  // Fetch all the groups in the company
  useEffect(() => {
    async function fetchGroupsViaStore(): Promise<void> {
      if (companyId) {
        await dispatch(
          fetchGroups({
            companyId,
          })
        );
      }
    }
    void fetchGroupsViaStore();
  }, [companyId, dispatch]);

  return groups;
}
